import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  FolderTree,
  Store,
  Users,
  CreditCard,
  Wallet,
  Star,
  Boxes,
  FileText,
  BarChart3,
  MessageSquare,
  Bell,
  Ticket,
  Settings,
  User,
  LogOut,
  Leaf,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react'

const menuItems = [
  { icon: LayoutDashboard, label: "Dashboard", href: "/admin" },
  { icon: ShoppingCart, label: "Orders", href: "/admin/orders" },
  { icon: Package, label: "Products", href: "/admin/products" },
  { icon: FolderTree, label: "Categories", href: "/admin/categories" },
  { icon: Store, label: "Sellers", href: "/admin/sellers" },
  { icon: Users, label: "Customers", href: "/admin/customers" },
  { icon: CreditCard, label: "Payments", href: "/admin/payments" },
  { icon: Wallet, label: "Payouts", href: "/admin/payouts" },
  { icon: Star, label: "Reviews", href: "/admin/reviews" },
  { icon: Boxes, label: "Inventory", href: "/admin/inventory" },
  { icon: FileText, label: "Reports", href: "/admin/reports" },
  { icon: BarChart3, label: "Analytics", href: "/admin/analytics" },
  { icon: MessageSquare, label: "Messages", href: "/admin/messages" },
  { icon: Bell, label: "Notifications", href: "/admin/notifications" },
  { icon: Ticket, label: "Coupons", href: "/admin/coupons" },
  { icon: Settings, label: "Settings", href: "/admin/settings" },
  { icon: User, label: "Profile", href: "/admin/profile" },
]

const AdminSidebar = ({ collapsed, onToggle }) => {
  const location = useLocation()

  const isActive = (href) => {
    if (href === '/admin') {
      return location.pathname === '/admin'
    }
    return location.pathname.startsWith(href)
  }

  return (
    <aside 
      className="admin-sidebar position-fixed start-0 top-0 h-100 bg-dark d-flex flex-column"
      style={{ 
        width: collapsed ? '70px' : '260px',
        zIndex: 1040,
        transition: 'width 0.3s ease'
      }}
    >
      {/* Logo */}
      <div className="d-flex align-items-center justify-content-between border-bottom border-secondary px-3" style={{ height: '64px' }}>
        <Link to="/admin" className="d-flex align-items-center gap-2 text-decoration-none text-white">
          <div className="bg-primary rounded d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
            <Leaf size={18} color="white" />
          </div>
          {!collapsed && <span className="fw-semibold">PlantAdmin</span>}
        </Link>
        <button
          onClick={onToggle}
          className="btn btn-sm btn-link text-white p-1 text-decoration-none"
        >
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-grow-1 overflow-auto py-3">
        <ul className="nav flex-column px-2">
          {menuItems.map((item) => {
            const active = isActive(item.href)
            return (
              <li key={item.href} className="nav-item mb-1">
                <Link
                  to={item.href}
                  className={`nav-link d-flex align-items-center gap-3 rounded px-3 py-2 ${active ? 'bg-primary text-white' : 'text-white-50'}`}
                  style={{ fontSize: '14px' }}
                  title={collapsed ? item.label : ''}
                >
                  <item.icon size={20} className="flex-shrink-0" />
                  {!collapsed && <span>{item.label}</span>}
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>

      {/* Logout */}
      <div className="border-top border-secondary p-2">
        <button
          className="btn btn-link text-white-50 text-decoration-none w-100 text-start d-flex align-items-center gap-3 rounded px-3 py-2"
          style={{ fontSize: '14px' }}
        >
          <LogOut size={20} />
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </aside>
  )
}

export default AdminSidebar